module.exports = __webpack_public_path__ + "img/Plus.b26990ec.svg";